// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
// import 'promise-polyfill/src/polyfill';

//import * as serviceWorker from './serviceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './components/App/App';
import store from './store/index';

import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import 'react-loading-bar/dist/index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-notifications-component/dist/theme.css';
import 'react-tabs/style/react-tabs.css';
import './static/sass/main.scss';

ReactDOM.render(
    <Provider store={ store }>
      <App />
    </Provider>,
  document.getElementById('root')
);
